import { memo, useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { getDownloaderFiles } from '@vt/apis/lib-ex/v2/downloadCenter'
import { useAppEx } from '@vt/hooks'

const DownloadStyled = styled.div`
  font-size: 14px;
  color: var(--ow-color-neutral-1200);
  .title {
    padding: 8px 0;
  }
  .btn {
    height: 32px;
    background: var(--ow-color-primary-700);
    border-radius: 4px;
    color: var(--ow-color-white-100);
    margin-top: 9px;
    text-align: center;
    line-height: 32px;
  }
  .desc {
    font-size: 12px;
    line-height: 17px;
  }
`

const SelectList = styled.div`
  font-size: 14px;
  color: var(--ow-color-neutral-1200);
  div {
    height: 36px;
    line-height: 36px;
    padding-left: 16px;
    border-radius: 3px;
    cursor: default;
    margin-bottom: 4px;
    &:hover {
      background: var(--ow-color-neutral-300);
    }
    &.active {
      color: var(--ow-color-white-100);
      background: var(--ow-color-primary-700);
    }
  }
`
const SelectOptions = [{ code: 0, name: '全部' }]
const SideBar = ({ onChange }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [downloaderUrl, setDownloaderUrl] = useState('')
  const { appId } = useAppEx()
  const onSelect = (index) => {
    setActiveIndex(index)
    onChange(SelectOptions[index].code)
  }
  const initDownloadInfo = async () => {
    const { pro2downloader32 = {} } = await getDownloaderFiles(appId)
    if (pro2downloader32.url) setDownloaderUrl(pro2downloader32.url)
  }
  useEffect(() => {
    initDownloadInfo()
  }, [])
  return (
    <div
      className="flex flex-col justify-between bg-white p-2"
      style={{ width: '160px' }}
    >
      <SelectList className="flex flex-col">
        {SelectOptions.map((item, index) => (
          <div
            key={`select-${index}`}
            className={activeIndex === index ? 'active' : ''}
            onClick={() => onSelect(index)}
          >
            {item.name}
          </div>
        ))}
      </SelectList>
      {downloaderUrl && (
        <DownloadStyled className="flex flex-col bg-indigo-50 p-2">
          <p className="title font-medium">明察暗访（新）</p>
          <p className="desc">推荐使用:</p>
          <p className="desc">
            明察暗访（新）下载器下载文件（仅支持windows系统），安装后使用当前账号登录进行下载。
          </p>
          <a
            className="btn"
            href={downloaderUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            下载
          </a>
        </DownloadStyled>
      )}
    </div>
  )
}

export default memo(SideBar)
